import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoGridOneColumn,
    RaikoGridThreeColumn, RaikoMobileInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, RaikoSimpleMultiLineInputOutlined, showServerErrorMessage, showSuccessMessage,
    RaikoButtonSecondary, RaikoFlexFirstChildGrowOne, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import {FeedBackService} from "../../serverService/feedbackService/FeedBackService";
import {useAuthState} from "../../context/AuthContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import React from "react";

export default function FeedbackInfo() {

    const [title, setTitle] = useState("");
    const [senderId, setSenderId] = useState("");
    const [fullName, setFullName] = useState("");
    const [groupName, setGroupName] = useState("");
    const [date, setDate] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [status, setStatus] = useState("AWAITING_FOR_REVIEW");
    const [description, setDescription] = useState("");

    const service = new FeedBackService()
    const {fundID} = useAuthState()
    const {id: feedbackId} = useParams()
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        getFeedbackInfoFromServer()
    }, [])

    function getFeedbackInfoFromServer() {
        loading.show()
        service.getFeedBackInfo(fundID, feedbackId).then(
            response => {
                setTitle(response.title)
                setSenderId(response.senderId)
                setFullName(`${response.senderFirstName} ${response.senderLastName}`)
                setGroupName(response.senderGroupName)
                setDate(convertUniversalDateTimeToPersianDateTime(response.sendAt))
                setPhoneNumber(response.senderPhoneNumber)
                setStatus(response.status)
                setDescription(response.description)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    const [value, setValue] = useState(FeedbackInfoTabTypes.BasicInfo.id);

    const navigate = useNavigate()

    function handleChangeTabMenu(event, newValue) {
        setValue(newValue)
        getFeedbackInfoFromServer()
    }

    function changeFeedbackStatus() {
        loading.show()
        service.changeFeedBackStatus(fundID, feedbackId, status).then(
            response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <RaikoBaseContainer>
            <RaikoFlexFirstChildGrowOne>
                <RaikoBreadcrumb
                    className={css`flex-grow: 1;
                      gap: .5rem;`}
                    breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.FeedBack.name,
                            RouteHelper.FeedBack.globalUrl
                        ),
                        raikoBreadCrumbItemGenerator(
                            fullName,
                            ""
                        )
                    ]}/>
                <RaikoButtonSecondary
                    label={"بازگشت"}
                    onClick={_ => {
                        navigate(-1)
                    }}
                />
            </RaikoFlexFirstChildGrowOne>
            <TabContext value={value}>
                <Box sx={{borderBottom: 1, borderColor: 'divider'}}
                     className={css`
                       border-color: var(--header-border-bottom-color) !important;
                       margin-top: 24px;
                     `}>
                    <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                        <Tab
                            label={FeedbackInfoTabTypes.BasicInfo.title}
                            value={FeedbackInfoTabTypes.BasicInfo.id}
                        />
                    </TabList>
                </Box>
                <TabPanel value={FeedbackInfoTabTypes.BasicInfo.id}>
                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"اطلاعات پایه"}
                            hasActionButton={true}
                            actionButtonOnclick={changeFeedbackStatus}
                        >
                            <RaikoGridOneColumn>
                                <RaikoGridThreeColumn>
                                    <RaikoSimpleInputOutlined
                                        labelText={"شناسه"}
                                        value={senderId}
                                        setValue={setSenderId}
                                        disabled={true}
                                    />
                                    <RaikoSimpleInputOutlined
                                        labelText={"عنوان"}
                                        value={title}
                                        setValue={setTitle}
                                        disabled={true}
                                    />
                                    <RaikoSimpleInputOutlined
                                        labelText={"نام و نام خانوادگی"}
                                        value={fullName}
                                        setValue={setFullName}
                                        disabled={true}
                                    />
                                    <RaikoSimpleInputOutlined
                                        labelText={"نام گروه"}
                                        value={groupName}
                                        setValue={setGroupName}
                                        disabled={true}
                                    />
                                    <RaikoSimpleInputOutlined
                                        labelText={"تاریخ"}
                                        value={date}
                                        setValue={setDate}
                                        disabled={true}
                                    />
                                    <RaikoMobileInputOutlined
                                        labelText={"تلفن همراه"}
                                        setValue={setPhoneNumber}
                                        value={phoneNumber}
                                        disabled={true}
                                    />
                                </RaikoGridThreeColumn>
                                <RaikoCustomSelect
                                    labelText={"وضعیت"}
                                    value={status}
                                    setValue={setStatus}
                                    items={[
                                        raikoCustomSelectItemGenerator("AWAITING_FOR_REVIEW", "در دست بررسی"),
                                        raikoCustomSelectItemGenerator("REVIEWED", "بررسی شده")
                                    ]}
                                />
                                <RaikoSimpleMultiLineInputOutlined
                                    labelText={"توضیحات"}
                                    value={description}
                                    disabled={true}
                                />

                            </RaikoGridOneColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>
                </TabPanel>

            </TabContext>

        </RaikoBaseContainer>
    )
}
export const FeedbackInfoTabTypes = {
    BasicInfo: {
        id: "basic-info",
        title: "اطلاعات پایه"
    },
}